import { useParams } from "react-router-dom";
import { get } from "lodash";
import { PaymentType } from "../../[orderId]/payment/[paymentId]/types";
import { useQuery } from "@apollo/client";
import { PAYMENT_QUERY } from "./queries";
import Progress from "@/components/Progress";
import EmptyState from "@/components/EmptyState";
import { useRequireCapability, DOMAIN, PERMISSION } from "@/hooks/useCapabilities";
import PaymentWrapper from "../../_components/PaymentWrapper";
import usePageTitle from "@/hooks/usePageTitle";

const Payment = () => {
  usePageTitle("/billing/orders/payment/:paymentId", "Billing | Orders | Payment Details");
  useRequireCapability({ domain: DOMAIN.COMMERCE, permission: PERMISSION.viewPayments });
  const { paymentId } = useParams();

  const { loading, error, data, refetch } = useQuery(PAYMENT_QUERY, { variables: { paymentId } });

  if (loading)
    return (
      <div className="p-10 flex items-center justify-center">
        <Progress />
      </div>
    );
  if (error) return <EmptyState title="Error" caption="An error occurred while loading this order." iconName="error" />;
  return (
    <PaymentWrapper
      payment={get(data, "commercePayment") as PaymentType}
      refetch={refetch}
      paymentQuery={PAYMENT_QUERY}
    />
  );
};

export default Payment;
